<div id="clinicalResults" style="padding: 8px;top:0;bottom:0;left:0;right: 0; height: 100%">
    <dx-tree-list
        #tree
        [dataSource]="dataSource"
        parentIdExpr="parentKey"
        keyExpr="key"
        [(expandedRowKeys)]="expandedKeys"
        [showRowLines]="true"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        [highlightChanges]="true"
        [columnAutoWidth]="true"
        height='100%'
        [allowColumnResizing]="true"
        [wordWrapEnabled]="true"
        (onCellPrepared)="conditionalRendering($event)"
        [columnHidingEnabled]="isPhoneOrTablet">
      <dxo-scrolling
        mode="standard"
        rowRenderingMode="standard"
        preloadEnabled="true"
      ></dxo-scrolling>
        <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
        <dxi-column caption="Name" cellTemplate="nameTemplate" [allowFiltering]="true" [calculateFilterExpression]="calculateNameFilter"
            [allowSorting]="true" [hidingPriority]="isPhoneOrTablet ? 4 : -1" width="60%"></dxi-column>
        <dxi-column caption="Result" cellTemplate="resultsTemplate" [allowFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 4 : -1"></dxi-column>
        <dxi-column dataField="flag" caption="Flag" [allowFiltering]="true" [allowSorting]="true" [hidingPriority]="isPhoneOrTablet ? 4 : -1"></dxi-column>
        <dxi-column dataField="unit" caption="Unit" [allowFiltering]="false" [hidingPriority]="isPhoneOrTablet ? 1 : -1"></dxi-column>
        <dxi-column caption="Reference Range" [allowFiltering]="false" cellTemplate="referenceRangeTemplate" [hidingPriority]="isPhoneOrTablet ? 0 : -1"></dxi-column>

        <div *dxTemplate="let result of 'nameTemplate'">
            {{result.data.name}}
            <span *ngIf="result.data.resultReportComments">
                <p [innerHtml]="transformYourHtml(result.data.resultReportComments)" style="border: 0; padding: 20px; overflow-x: auto"></p>
            </span>
        </div>

        <div *dxTemplate="let result of 'resultsTemplate'">
            {{result.data.result}}
            <span *ngIf="result.data.comment">
                <p *ngIf="result.data.comment" [innerHtml]="transformYourHtml(result.data.comment)" style="border: 0; padding: 20px; overflow-x: auto"></p>
            </span>
        </div>

        <div *dxTemplate="let result of 'referenceRangeTemplate'">
            {{result.data.referenceRange}}
            <span *ngIf="result.data.clinicalRangeComment">
                <p *ngIf="result.data.clinicalRangeComment" [innerHtml]="transformYourHtml(result.data.clinicalRangeComment)" style="border: 0; padding: 20px; overflow-x: auto"></p>
            </span>
        </div>
    </dx-tree-list>
</div>
